export default __webpack_public_path__ + "static/mitech-client-logo-02-2426bde32decd0c86673c58e0a5f6e03.png";